import { FC, useEffect } from "react";
import { Col, Form, FormGroup, Label, Row } from "reactstrap";
import ModalComponent from "../../shared/base-components/Modal";
import TextField from "../../shared/base-components/TextField";
import { SubmitHandler, useForm } from "react-hook-form";
import Button from "../../shared/base-components/Button";
import DatePicker from "../../shared/base-components/DatePicker";
import { MODAL_TYPES, RESPONSE_CODE } from "../../shared/models/Types";
import { successNotify } from "../../shared/utils/notifications";

import SelectBox from "../../shared/base-components/SelectBox";
import SearchableSelectBox from "../../shared/base-components/SearchableSelectBox";
import {
  AppointmentModalProps,
  AppointmentUpdateRequest,
  appointmentAddSchema,
  appointmentUpdateSchema,
} from "./Appointment.constants";
import {
  useAppointmentAddMutation,
  useAppointmentUpdateMutation,
} from "./Appointment.actions";

import { yupResolver } from "@hookform/resolvers/yup";

const TodoModal: FC<AppointmentModalProps> = ({
  userData,
  isModalOpen,
  modalType,
  toggle,
  mutate,
  customerListData,
}) => {
  const isEdit = modalType === MODAL_TYPES.UPDATE;

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<any>({
    resolver: yupResolver(
      isEdit ? appointmentUpdateSchema : appointmentAddSchema
    ),
  });

  const {
    data,
    mutate: appointmentAddMutate,
    isLoading,
  } = useAppointmentAddMutation();

  const {
    data: updateData,
    mutate: appointmentUpdate,
    isLoading: updateLoading,
  } = useAppointmentUpdateMutation();

  const onSubmit: SubmitHandler<any> = (
    requestValues: AppointmentUpdateRequest
  ) => {
    const filteredCustomer = customerListData?.results?.find(
      (customer) => customer.fullname === requestValues.customer
    )?.id;

    if (filteredCustomer) {
      const requestForm: AppointmentUpdateRequest = {
        id: userData?.id,
        customer: filteredCustomer?.toString(),
        appointment_type: requestValues.appointment_type
          ? requestValues.appointment_type
          : 1,
        note: requestValues.note,
        appointment_datetime: requestValues.appointment_datetime,
      };

      isEdit
        ? appointmentUpdate(requestForm)
        : appointmentAddMutate(requestForm);
    }
  };

  const onAppointmentCompleteHandler = () => {
    appointmentUpdate({
      id: userData?.id,
      customer: userData.customer.id,
      is_completed: true,
    });
  };

  useEffect(() => {
    if (data?.status === RESPONSE_CODE.CREATED) {
      successNotify("Randevu başarılı bir şekilde oluşturuldu");
      toggle();
      mutate && mutate({});
    }
  }, [data]);

  useEffect(() => {
    if (updateData?.status === RESPONSE_CODE.SUCCESS_CODE) {
      successNotify("Randevu başarılı bir şekilde güncellendi");
      toggle();
      mutate && mutate({});
    }
  }, [updateData]);

  const valueData = customerListData?.results?.map((customer) => ({
    value: customer.fullname,
  }));

  const defaultCustomerName = isEdit
    ? customerListData?.results?.find(
        (customer) => customer?.id == userData?.customer.id
      )?.fullname
    : "";

  return (
    <ModalComponent
      header={isEdit ? "Randevu  Güncelle" : "Randevu Ekle"}
      description={
        isEdit
          ? "Randevu Güncellemek için ilgili alanı düzeltip onaylayın"
          : "Randevu eklemek için gerekli alanları doldurunuz."
      }
      isOpen={isModalOpen}
      toggle={toggle}
    >
      <Form onSubmit={handleSubmit(onSubmit)} className="custom-form mt-4 pt-2">
        <Row>
          <Col sm="12" md="6" lg="6">
            <FormGroup className="mb-3">
              <Label className="form-label">Müşteri seçiniz</Label>
              {valueData && (
                <SearchableSelectBox
                  control={control}
                  name="customer"
                  className="form-control"
                  options={valueData}
                  defaultValue={isEdit ? defaultCustomerName : ""}
                  error={errors.customer?.message}
                />
              )}
            </FormGroup>
          </Col>

          <Col sm="12" md="6" lg="6">
            <FormGroup className="mb-3">
              <Label className="form-label">Randevu Tipi</Label>
              <SelectBox
                control={control}
                name="appointment_type"
                defaultValue={isEdit ? userData?.appointment_type : 1}
                className="form-control"
                options={[
                  { key: "İlk Kurulum", value: 1 },
                  { key: "Bakım", value: 2 },
                  { key: "Bilgi", value: 3 },
                  { key: "Diğer", value: 4 },
                ]}
              />
            </FormGroup>
          </Col>

          <Col sm="12" md="6" lg="6">
            <FormGroup className="mb-3">
              <Label className="form-label">Randevu Tarihi</Label>
              <DatePicker
                enableTime
                control={control}
                name="appointment_datetime"
                type="text"
                className="form-control"
                defaultValue={
                  isEdit ? userData?.appointment_datetime : new Date()
                }
                error={errors.appointment_datetime?.message}
              />
            </FormGroup>
          </Col>

          <Col sm="12" md="12" lg="12">
            <FormGroup className="mb-3">
              <Label htmlFor="validationCustom02">Not</Label>
              <TextField
                control={control}
                className="form-control"
                name="note"
                defaultValue={isEdit ? userData?.note : ""}
                type="textarea"
                error={errors.note?.message}
              />
            </FormGroup>
          </Col>

          <Col md="12">
            <FormGroup className="mb-3">
              <Button
                loading={isEdit ? updateLoading : isLoading}
                text={isEdit ? "Randevu Güncelle" : "Randevu Ekle"}
                variant="primary"
              />
            </FormGroup>

            {isEdit && (
              <FormGroup className="mb-3">
                <Button
                  type="button"
                  onClick={onAppointmentCompleteHandler}
                  loading={isEdit ? updateLoading : isLoading}
                  text="Tamamla"
                  variant="success"
                  iconSrc="check-double"
                />
              </FormGroup>
            )}
          </Col>
        </Row>
      </Form>
    </ModalComponent>
  );
};

export default TodoModal;
